import { memo, MouseEvent, useEffect, useState } from 'react'
import { IconButton, Menu, MenuItem } from '@mui/material'
import { IScheduleIconComponent } from '../../../Models'
import { DataPinnedItemIcon, DataUnpinnedItemIcon, RedCrossIcon } from '../../Icons'
import {
  AccessTime,
  KeyboardArrowDown,
  KeyboardArrowUp,
  SettingsOutlined,
} from '@mui/icons-material'
import scheduleIconStyle from './ScheduleIcon.module.scss'

const ScheduleIconComponent = ({
  data,
  disabled,
  handleScheduleClick,
  isPinnedItemDisabled,
  type,
}: IScheduleIconComponent) => {
  const [isIconDisabled, setIsIconDisabled] = useState(false)
  const [editScheduleAnchorEl, setEditScheduleAnchorEl] = useState<null | HTMLElement>(null)
  const pinnedModalOpen = Boolean(editScheduleAnchorEl)

  useEffect(() => {
    setIsIconDisabled(type === 'manualPin' ? isPinnedItemDisabled : disabled)
  }, [type, isPinnedItemDisabled, disabled])

  const handleClose = () => {
    setEditScheduleAnchorEl(null)
  }

  return (
    <>
      <IconButton
        onClick={(event) => {
          event.stopPropagation()
          if (data?.isPinned) {
            setEditScheduleAnchorEl(editScheduleAnchorEl ? null : event.currentTarget)
          } else {
            handleScheduleClick?.(data.id, 'pin')
          }
        }}
        id='schedule-icon-btn'
        aria-label='schedule-icon'
        data-testid={'pinIcon'}
        className={scheduleIconStyle['schedule_icon']}
        aria-controls={pinnedModalOpen ? 'pinned-item-menu' : undefined}
        aria-haspopup={data?.isPinned}
        aria-expanded={pinnedModalOpen ? 'true' : undefined}
        style={{
          background: data?.isPinned ? '#ece9f2' : '#fff',
          opacity: isIconDisabled ? 0.5 : 1,
        }}
        disabled={isIconDisabled}
      >
        {type === 'pin' ? (
          <AccessTime color='primary' fontSize='small' />
        ) : data?.isPinned ? (
          <div className='d-flex align-items-center' style={{ gap: '0.25rem' }}>
            <DataPinnedItemIcon />
            {pinnedModalOpen ? (
              <KeyboardArrowUp className={scheduleIconStyle['arrow_icon']} />
            ) : (
              <KeyboardArrowDown className={scheduleIconStyle['arrow_icon']} />
            )}
          </div>
        ) : (
          <DataUnpinnedItemIcon />
        )}
      </IconButton>
      {pinnedModalOpen && (
        <Menu
          id='pinned-item-menu'
          anchorEl={editScheduleAnchorEl}
          open={pinnedModalOpen}
          onClose={handleClose}
          onClick={(event: MouseEvent<HTMLDivElement>) => {
            handleScheduleClick?.(
              data.id,
              (event.target as HTMLElement).id === 'unpin' ? 'remove' : 'update',
            )
            handleClose()
          }}
          style={{
            marginTop: '6px',
            left: '-105px',
          }}
        >
          <MenuItem
            id='edit_pin_setting'
            style={{ gap: '0.5rem', color: '#0a0a0a', fontSize: '14px', lineHeight: '20px' }}
          >
            <SettingsOutlined style={{ color: '#402080', width: '14px', height: '14px' }} /> Edit
            Pin Settings
          </MenuItem>
          <MenuItem
            id='unpin'
            style={{ gap: '0.5rem', color: '#e7000b', fontSize: '14px', lineHeight: '20px' }}
          >
            <RedCrossIcon width={14} height={14} />
            Unpin
          </MenuItem>
        </Menu>
      )}
    </>
  )
}

export default memo(ScheduleIconComponent)
